<template>
  <div class="edit-image-text">
    <!-- 各パーツの編集 -->
    <div v-if="showTabContent || showTabStyle">
      <!-- 画像パーツ -->
      <image-edit
        :current="currentImage"
        :parts="parts.filter(part => part.type === 'Image')"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :partsContainerType="partsContainerType"
        :partsContainerStyles="styles"
      />
      <!-- テキストパーツ -->
      <text-edit
        :current="currentText"
        :parts="parts.filter(part => part.type === 'Text')"
        :sectionId="sectionId"
        :partsContainerId="partsContainerId"
        :extTypeName="extTypeName"
      />
    </div>
    <!-- レイアウト -->
    <setting
      v-if="showTabSetting"
      :sectionId="sectionId"
      :partsContainerId="partsContainerId"
      :parts="parts"
      :partsContainerType="partsContainerType"
      :partsContainerStyles="styles"
      :spacerParts="spacerParts"
      :flgSide="flgSide"
      :flgImageContentMobileFullWidth="flgImageContentMobileFullWidth"
      @adjustCurrentTableId="$emit('adjustCurrentTableId', $event)"
    />
  </div>
</template>

<script>
import ImageEdit from '@/components/Content/Palette/EditPartDesign/Editor/Image'
import TextEdit from '@/components/Content/Palette/EditPartDesign/Editor/Text'
import Setting from '@/components/Content/Palette/EditPartDesign/Editor/ImageText/ImageTextSetting'

export default {
  props: [
    'current',
    'styles',
    'parts',
    'sectionId',
    'partsContainerId',
    'partsContainerType',
    'isMultiPart',
    'flgSide',
    'flgImageContentMobileFullWidth',
    'extTypeName',
  ],
  data () {
    return {
      currentImage: {
        tab: null,
        tableId: null,
      },
      currentText: {
        tab: null,
        tableId: null,
      },
    }
  },
  components: {
    ImageEdit,
    TextEdit,
    Setting,
  },
  computed: {
    showTabContent () {
      return this.current.tab === 'Content'
    },
    showTabStyle () {
      return this.current.tab === 'Style'
    },
    showTabSetting () {
      return this.current.tab === 'Setting'
    },
    imageTableId () {
      let imageTableId
      if (this.isMultiPart.column || this.isMultiPart.row) {
        imageTableId = this.current.tableId
      } else {
        // マルチcolumnでもrowでもない場合：Imageパーツの、テーブルIDを取得
        const imagePart = this.parts.find(part => part.type === 'Image')
        imageTableId = imagePart['table_id']
      }
      return imageTableId
    },
    textTableId () {
      let textTableId
      if (this.isMultiPart.column || this.isMultiPart.row) {
        textTableId = this.current.tableId
      } else {
        // マルチcolumnでもrowでもない場合：Textのパーツの、テーブルIDを取得
        const textPart = this.parts.find(part => part.type === 'Text' || part.type === 'BoxedText')
        textTableId = textPart['table_id']
      }
      return textTableId
    },
    spacerParts () {
      if (!this.parts) return null
      return this.parts.filter(part => part.type === 'Spacer' && part.order_id === 1)
    },
  },
  methods: {
    initComponent () {
      this.currentImage = { tab: this.current.tab, tableId: this.imageTableId }
      this.currentText = { tab: this.current.tab, tableId: this.textTableId }
    }
  },
  mounted () {
    this.initComponent()
  },
  watch: {
    isMultiPart: {
      deep: true,
      handler: function () {
        this.initComponent()
      }
    },
  },
}
</script>

<style lang="scss">
.edit-image-text {
  .image-text-setting {
    .layouts-parts-container-style {
      .edit-style-select-color {
        .window {
          // パーツの背景色カラーピッカー
          top: -275px;
        }
      }
    }
  }
}
</style>
